export default __webpack_public_path__ + "static/generator_w.4716ee9868faef0a99f4cfcc7e8df448.png";